module.exports = __webpack_public_path__ + "static/media/2020_0814_21325300-01.000dd868.jpg";